import { useLocation } from 'react-router-dom';
import { ADMIN_BASE_PATH } from '@/config/admin-routes';

const ICP_RECORD_NUMBER = '粤ICP备2026106748号';
const PUBLIC_SECURITY_RECORD_NUMBER = '粤公网安备44030002015442号';
const PUBLIC_SECURITY_RECORD_URL =
  'https://beian.mps.gov.cn/#/query/webSearch?code=44030002015442';
const PUBLIC_SECURITY_BADGE_URL =
  'https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png';

export default function IcpFooter() {
  const { pathname } = useLocation();

  if (pathname.startsWith(ADMIN_BASE_PATH)) {
    return null;
  }

  return (
    <footer className="border-t border-orange-100 bg-[#fffaf5] px-4 py-4 text-center text-xs text-stone-500">
      <details className="mx-auto mb-3 max-w-3xl text-left">
        <summary className="cursor-pointer text-center">数据说明</summary>
        <p className="mt-2">本站以浏览器随机编号估算访问、主题详情与客服点击，不是精确真人数。脚本可排除常见链接预览，但不能保证排除所有爬虫。统计不保存姓名、兑换码、完整IP或原始网址；不采集搜索词。领取数据来自原业务记录，不与访客或渠道关联。</p>
        <p className="mt-2">行为明细保留最近90个北京时间自然日，日和自然周汇总长期保留。既有数据库备份可能保留清理前的数据：本地备份按超过14天清理，云端备份实际保留期尚未核实；Nginx访问日志每日轮转保留14份。</p>
      </details>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <a
          className="transition-colors hover:text-orange-600"
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noreferrer"
        >
          {ICP_RECORD_NUMBER}
        </a>
        <a
          className="inline-flex items-center gap-1 transition-colors hover:text-orange-600"
          href={PUBLIC_SECURITY_RECORD_URL}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={PUBLIC_SECURITY_BADGE_URL}
            alt=""
            aria-hidden="true"
            width="16"
            height="17"
            className="h-[17px] w-4 shrink-0"
          />
          <span>{PUBLIC_SECURITY_RECORD_NUMBER}</span>
        </a>
      </div>
    </footer>
  );
}
